import { render, staticRenderFns } from "./ShowCotation.vue?vue&type=template&id=779f4e18&scoped=true"
import script from "./ShowCotation.vue?vue&type=script&lang=ts"
export * from "./ShowCotation.vue?vue&type=script&lang=ts"
import style0 from "./ShowCotation.vue?vue&type=style&index=0&id=779f4e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f4e18",
  null
  
)

export default component.exports